// This file is generated automatically by the buildInfo script
export const buildInfo = {
  coreBuildDate: '22/10/2026, 9:52:57',
  coreVersion: '4.96.0-SNAPSHOT',
  coreRevision: '83d83ae50cc6678baa4d313486cdf69c251e6036',
  coreBranch: 'develop'
};
